module.exports = __webpack_public_path__ + "img/accounts.eb32e1d5.jpg";